var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#login_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 4.375a3.438 3.438 0 1 0 0 6.875 3.438 3.438 0 0 0 0-6.875Zm0 5a1.562 1.562 0 1 1 0-3.126 1.562 1.562 0 0 1 0 3.126ZM10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0Zm0 18.125a8.068 8.068 0 0 1-4.863-1.632 3.891 3.891 0 0 1 3.465-2.118h2.8c1.475 0 2.786.82 3.464 2.118A8.086 8.086 0 0 1 10 18.125Zm6.258-2.95c-1.055-1.648-2.852-2.675-4.86-2.675H8.602c-2.007 0-3.803 1.025-4.86 2.675A8.082 8.082 0 0 1 1.875 10c0-4.48 3.645-8.125 8.125-8.125S18.125 5.52 18.125 10c0 1.965-.703 3.77-1.867 5.176Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "login_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgLogin;